import { render, staticRenderFns } from "./UploadImgList2.vue?vue&type=template&id=6f54183e&scoped=true"
import script from "./UploadImgList2.vue?vue&type=script&lang=js"
export * from "./UploadImgList2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f54183e",
  null
  
)

export default component.exports